const styles = theme => ({
  root: {
    marginTop: 40
  },
  shipmentsContainer: {
    position: 'relative',
    width: '100%'
  },
  filterContainer: {
    padding: '0 12px',
    textAlign: 'right',
    [theme.breakpoints.down('xs')]: {
      marginTop: 25,
      '& ~ &': { marginTop: 10 }
    }
  },
  infoContainer: {
    position: 'relative',
    width: '100%'
  },
  comboFilter: {
    maxWidth: 260,
    width: '100%',
    [theme.breakpoints.down('xs')]: { maxWidth: '100%' }
  },
  search: {
    height: 58
  }
});

export default styles;
